import React, { HTMLAttributes } from 'react'
import { CountryCode } from 'libphonenumber-js'
import styled from 'styled-components'
import flagsDict from './flagsDict'

const StyledImg = styled.img`
  box-shadow: 0 0 1px rgba(0, 0, 0, 0.5);
`

const Stub = styled.span`
  width: ${(props: { size: number }) => `${props.size}px`};
  padding-top: ${(props: { size: number }) => `calc(${props.size}px * 0.6)`};
  display: inline-block;
  background: linear-gradient(
    45deg,
    rgba(0, 0, 0, 0.2) 0%,
    rgba(0, 0, 0, 0.2) 30%,
    rgba(0, 0, 0, 0.15) 30%,
    rgba(0, 0, 0, 0.15) 65%,
    rgba(0, 0, 0, 0.1) 65%
  );
`

export const Flag: React.FC<{ code: CountryCode | 'EU'; className?: string; width?: number } & HTMLAttributes<
  HTMLImageElement
>> = ({ code, className, width = 20, ...props }) => {
  const flag = flagsDict[code]
  return flag ? <StyledImg {...props} className={className} src={flag} width={width} /> : <Stub size={width} />
}
